import type { FC } from "react";

import { StatusBadge } from "@/components/ui/status-badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";

import { WEIGHT } from "../sources";
import type { AuthorityWeight } from "../types";

/**
 * What an authority is worth, with why on hover. A hit the library didn't
 * label (or labeled with a weight this build doesn't know) renders nothing,
 * so one odd result can't take down the page.
 */
export const WeightBadge: FC<{ weight: string | null | undefined }> = ({
  weight
}) => {
  const known = weight ? WEIGHT[weight as AuthorityWeight] : undefined;
  if (!known) return null;
  const { label, tone, hint } = known;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <StatusBadge tone={tone} data-testid={`weight-${weight}`}>
          {label}
        </StatusBadge>
      </TooltipTrigger>
      <TooltipContent side="top">{hint}</TooltipContent>
    </Tooltip>
  );
};
